export default "__VITE_ASSET__DxK_UvGV__"